import React, {useEffect, useRef, useState} from 'react';
import HeaderIconWithBadge from '@header/scripts/components/HeaderIconWithBadge.jsx';
import UserFlyout from '@header/scripts/components/user/UserFlyout.jsx';
import LandmarkAdapter from '@core/scripts/components/landmark-adapter.js';
import History from '@core/scripts/components/history.js';
import MessageBroker from '@bonprix/pattern-library/components/message-broker.js';
import Topics from '@core/scripts/components/topics.js';

export default function User({user, deviceType}) {
    const [flyoutOpened, setFlyoutOpened] = useState(false);
    const userRef = useRef(null);

    useEffect(() => {
        const messages = [MessageBroker.subscribe(`${Topics.HISTORY}.my-account`, closeFlyout)];

        return () => {
            messages.forEach((message) => MessageBroker.unsubscribe(message));
        };
    }, []);

    const toggleFlyout = () => {
        if (flyoutOpened) {
            History.remove('my-account');
        } else {
            History.push('my-account');
        }
        setFlyoutOpened(!flyoutOpened);
        const lmValue = {navi: `"tn\\myaccount\\\\${deviceType}\\"`};
        LandmarkAdapter.sendUserInterfaceLandmark(lmValue);
    };

    const closeFlyout = () => {
        setFlyoutOpened(false);
        History.remove('my-account');
    };

    useEffect(() => {
        if (flyoutOpened) {
            document.addEventListener('click', handleClickOutside);
        }

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [flyoutOpened]);

    const handleClickOutside = (event) => {
        if (userRef.current && !userRef.current.contains(event.target)) {
            closeFlyout();
        }
    };

    return (
        <div className="header__user-wrapper" ref={userRef}>
            <button className="header__icon-box" aria-label={user.texts.ho_meta_nav_myAccount} onClick={toggleFlyout}>
                <HeaderIconWithBadge iconName="user" checked={user.userStatus.loggedIn} />
            </button>

            {flyoutOpened && (
                <UserFlyout
                    userStatus={user.userStatus}
                    texts={user.texts}
                    links={user.links}
                    closeFlyout={closeFlyout}
                />
            )}
        </div>
    );
}
